"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.comparableProductOf = exports.coversRange = exports.apportionMeasureValuesMap = exports.apportionMeasureValue = exports.getApportionToTimeBucketsMap = exports.getTimeBuckets = exports.getCurrentTimeBucket = exports.isInTimeBucket = void 0;
const lambda_1 = require("../../lambda");
const math_1 = require("../../math");
const getTimeBucketStartDateTimeForTimestamp_1 = require("./getTimeBucketStartDateTimeForTimestamp");
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && false);
const isInTimeBucket = (timestampMs, timeBucket) => {
    const [startTimestamp, endTimestamp] = timeBucket;
    return startTimestamp <= timestampMs && endTimestamp > timestampMs;
};
exports.isInTimeBucket = isInTimeBucket;
/**
 * @function getCurrentTimeBucket returns the currentTimeBucket for single timestamp
 * @param param0
 * @returns
 */
const getCurrentTimeBucket = (timeBucketDef, timestamp) => {
    const currentBuckets = (0, exports.getTimeBuckets)({ timeBucketDef, startTimestamp: timestamp, endTimestamp: timestamp });
    return currentBuckets[0];
};
exports.getCurrentTimeBucket = getCurrentTimeBucket;
/**
 * @function getTimeBuckets returns the time buckets which cover the time range based in the definition
 * @param TimeBucketRequest
 * @returns TimeBucket[]
 */
const getTimeBuckets = ({ timeBucketDef, startTimestamp, endTimestamp }) => {
    const buckets = [];
    const iterationDate = (0, getTimeBucketStartDateTimeForTimestamp_1.getTimeBucketStartDateTimeForTimestamp)({ timeBucketDef, timestamp: startTimestamp });
    let bucketStart = iterationDate.valueOf();
    do {
        const bucketEnd = (0, getTimeBucketStartDateTimeForTimestamp_1.getTimeBucketEnd)({ timeBucketDef, timeBucketStartTimestamp: bucketStart });
        const timeBucket = [bucketStart, bucketEnd];
        buckets.push(timeBucket);
        bucketStart = bucketEnd;
    } while (bucketStart <= endTimestamp);
    return buckets;
};
exports.getTimeBuckets = getTimeBuckets;
/**
 * @function getApportionToTimeBucketsMap return the time buckets covering a range and returns the buckets plus the proportion of a value that should be put in each bucket
 * @param GetApportionToTimeBucketsMapRequest
 * @returns GetApportionToTimeBucketMapResponse
 */
const getApportionToTimeBucketsMap = ({ timeBucketDef, measureRange }) => {
    const buckets = (0, exports.getTimeBuckets)({ timeBucketDef, startTimestamp: measureRange.fromTimestamp, endTimestamp: measureRange.toTimestamp });
    const meaureLength = measureRange.toTimestamp - measureRange.fromTimestamp;
    const apportionedRes = buckets
        .map((bucket, i) => {
        const overlap = (0, math_1.getOverlapLength)([bucket, [measureRange.fromTimestamp, measureRange.toTimestamp]]);
        debug && (isNaN(overlap) || overlap === 0) && console.log(`Zero overlap with`, { bucket, measureRange });
        if (overlap == 0)
            return null;
        const apportionment = overlap / meaureLength;
        debug && console.log('getApportionToTimeBucketsMap', { overlap, apportionment, measureRange });
        return {
            bucketIndex: i,
            bucket,
            overlap,
            apportionment,
        };
    })
        .filter((b) => b != null);
    return apportionedRes;
};
exports.getApportionToTimeBucketsMap = getApportionToTimeBucketsMap;
/**
 * @functin apportionMeasure returns the proportion of a value to be added to overlapping time buckets
 * @param param0
 * @returns
 */
const apportionMeasureValue = ({ timeBucketDef, measureValueRange }) => {
    const apportionedFactorRes = (0, exports.getApportionToTimeBucketsMap)({ timeBucketDef, measureRange: measureValueRange });
    const apportionedRes = apportionedFactorRes.map((bucketRes) => ({
        ...bucketRes,
        apportionedValue: bucketRes.apportionment * measureValueRange.value,
    }));
    return apportionedRes;
};
exports.apportionMeasureValue = apportionMeasureValue;
/**
 * @functin apportionMeasure returns the proportion of a value to be added to overlapping time buckets
 * @param param0
 * @returns
 */
const apportionMeasureValuesMap = ({ timeBucketDef, measureValueMapRange }) => {
    const apportionedFactorRes = (0, exports.getApportionToTimeBucketsMap)({ timeBucketDef, measureRange: measureValueMapRange });
    const apportionedRes = apportionedFactorRes.map((bucketRes) => ({
        ...bucketRes,
        apportionedValuesMap: getApportionedValuesMap(bucketRes, measureValueMapRange.valueMap),
    }));
    return apportionedRes;
};
exports.apportionMeasureValuesMap = apportionMeasureValuesMap;
const getApportionedValuesMap = (bucketRes, valuesMap) => {
    const apportionedValuesMap = Object.fromEntries(Object.entries(valuesMap).map(([k, v]) => [k, v && typeof v === 'number' && !isNaN(v) ? bucketRes.apportionment * v : null]));
    return apportionedValuesMap;
};
/**
 * @function coversRange determines whether an array of timestamps with first being beginning of period, last end, fully spans a time bucket, with no one sub period being fully outside bucket range
 * This most likely applies to updating Normalized CMV which needs one hit
 * @param bucket
 * @param timestamps
 * @returns
 */
const coversRange = (bucket, timestamps) => {
    const isAscending = timestamps.every((t, i) => t >= (timestamps[i - 1] ?? 0));
    if (!isAscending) {
        console.log('WARN: Not ordered returing false', timestamps);
        return false;
    }
    else {
        const [fromTimestamp, ...evaluatableTimestamps] = timestamps;
        const endTimestamp = timestamps[timestamps.length - 1];
        /**
         * @returns note timestamps[ i ] because it is one before evaluatableTimestamps[ i ]
         */
        return (evaluatableTimestamps.every((timestamp, i) => (0, math_1.getOverlapLength)([bucket, [timestamps[i] ?? -Infinity, timestamp]]) > 0 || timestamps[i] === timestamp) &&
            fromTimestamp <= bucket[0] &&
            endTimestamp >= bucket[1]);
    }
};
exports.coversRange = coversRange;
const comparableProductOf = (args, rx) => args.reduce((a, c, i) => {
    const multipliers = rx.slice(0, args.length - i);
    return a + c * multipliers.reduce((a, c) => a * c);
}, 0);
exports.comparableProductOf = comparableProductOf;
